import React from 'react';
import Team from '../containers/team/Team';
import Cookies from '../containers/cookies/Cookies'
import TopBar from '../containers/topBar/TopBar';
import References from '../containers/references/References';
import Accomplishments from '../containers/accomplishments/Accomplishments';
import { AboutUs } from '../containers/aboutUs/AboutUs';
import { Intro } from '../containers/intro/Intro';
import { Quote } from '../containers/quote/Quote';
import { Sponsors } from '../containers/sponsors/Sponsors';
import { Partners } from '../containers/partners/Partners';
import { Footer } from '../containers/footer/Footer';
import { accessCookie } from './AppHelpers';
import './reset.css';
import './app.css';

class App extends React.Component {
  render() {
    return (
      <div className='pageWrapper'>
        <TopBar />
        <Intro />
        <Partners />
        <Quote />
        <AboutUs />
        <References />
        <Accomplishments />
        <Sponsors />
        <Team />
        <Footer />
        {accessCookie('cookiesAccepted') !== '1' && <Cookies />}
      </div>
    );
  }
}

export default App;


// WEBPACK FOOTER //
// ./src/app/App.js